// constants.js

(function() {
    'use strict';

    angular
        .module('appClient')
        .constant('VUE_ALL', 'all')
        .constant('VUE_GLOBAL', 'global');
})();